module.exports = __webpack_public_path__ + "static/media/LogoHelenLabs.0e9c2684.svg";